const BASE_API_URL = "https://be.profile-pengendalian.mtg.co.id";

export default {
    baseApiUrl: BASE_API_URL
}
